import Vue from 'vue';
import Vuex from 'vuex';
// import createPersistedState from "vuex-persistedstate"; 
import { auth } from '@/store/modules/authentication';
import { nav } from '@/store/modules/navigation';
import { childcare } from '@/store/modules/childcare/index';
import { child } from '@/store/modules/child/index';
import payments from '@/store/modules/payments';
import { admin } from '@/store/modules/admin/admin';
import booking from '@/store/modules/booking';
import { userChat } from '@/store/modules/chat/userChat';
import chat from '@/store/modules/chat';
import log from '@/store/modules/log';
import file from '@/store/modules/file';
import states from '@/store/modules/states';
import { waitlistStore } from '@/store/modules/waitlist';
import providerModule from '@/store/modules/enrollment/childcare-provider';
import { applicationLayoutFooterStore } from '@/store/modules/footer';
import { surveyStore } from '@/store/modules/surveys';
import { locationStore } from '@/store/modules/location'
import userSubscriptions from '@/store/modules/users';
// import { waitlist } from '@/store/modules/waitlist
// import { filters } from '@/store/modules/filters';

Vue.use(Vuex);
const store = new Vuex.Store({
  plugins: [
    // createLogger()
  ],
  state: {
  },
  getters: {
  },
  actions: {
    clearAll({ commit }: any) {
      store.dispatch("auth/clear")
        .catch((error) => console.log(error));

      store.dispatch("child/clear")
        .catch((error) => console.log(error));

      store.dispatch("payments/clear")
        .catch((error) => console.log(error));

      store.dispatch("admin/clear")
        .catch((error) => console.log(error));

      store.dispatch("childcare/clear")
        .catch((error) => console.log(error));

      store.dispatch("userChat/clear")
        .catch((error) => console.log(error));

      store.dispatch("booking/clear")
        .catch((error) => console.log(error));

      store.dispatch("nav/clear")
        .catch((error) => console.log(error));

      store.dispatch("states/clear")
        .catch((error) => console.log(error));
    }
  },
  mutations: {
    clearAll(state: any) {
      state.commit("clearAll");
    }
  },
  modules: {
    auth,
    nav,
    child,
    payments,
    admin,
    childcare,
    booking,
    userChat,
    chat,
    log,
    file,
    states,
    waitlistStore,
    applicationLayoutFooterStore,
    providerModule,
    surveyStore,
    locationStore,
    userSubscriptions
    // filters
  }
});

export default store;